<div class="wrap">
  <h2>{{title}}</h2>
  <form [formGroup]="federationForm" id="federationForm" class="input_google_search"
    (ngSubmit)="onSubmit()" *ngIf="federationForm">

    <mat-form-field appearance="outline">
      <mat-label>Label</mat-label>
      <input matInput type="text" formControlName="label" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Description</mat-label>
      <input matInput type="text" formControlName="description" />
    </mat-form-field>

  </form>

  <div class="btn_action">
    <button type="button" class="back" (click)="dialogRef.close()">Fermer</button>
    <button type="submit" class="confirm" form="federationForm" [disabled]="federationForm.invalid"
      [style.opacity]="federationForm.invalid? .5 : 1" appChangeColorTheme attribute="bgc">{{btnConfirm}}</button>

  </div>
</div>
